const items = [
  "120+ Years' Combined Experience",
  "Leadership Development",
  "Business Growth",
  "Digital Literacy",
  "Customer-Centric Performance",
  "Tailored Training Solutions",
];

export default function Credibility() {
  return (
    <section
      data-testid="credibility-strip"
      className="relative py-8 md:py-10 border-y border-slate-900/5 bg-[#f4f1ea]/60 overflow-hidden"
    >
      <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#f4f1ea]/95 to-transparent z-10 pointer-events-none" />
      <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#f4f1ea]/95 to-transparent z-10 pointer-events-none" />

      <div className="flex marquee-track w-max gap-12 md:gap-20">
        {[...items, ...items, ...items].map((label, i) => (
          <div
            key={i}
            data-testid={`credibility-item-${i}`}
            className="flex items-center gap-3 whitespace-nowrap"
          >
            <span className="size-2 rounded-full bg-orange-600" />
            <span className="font-display-medium text-slate-900 text-[15px] md:text-[16px] tracking-tight">
              {label}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
